const LOCAL_STORAGE = {
  TOKEN: "token",
  PATIENT_ID: "patient_id",
};

export default LOCAL_STORAGE;
